<template>
  <div class="wrap">
    <div class="bc" style="position: relative">
      <div class="row-content">
        <el-row :gutter="24" class="search-row" type="flex">
          <el-col :span="6">
            <div class="col-field">结算单号：</div>
            <div class="col-text">{{ form.id }}</div>
          </el-col>
          <el-col :span="6">
            <div class="col-field">结算单生成时间：</div>
            <div class="col-text">{{ form.createTime }}</div>
          </el-col>
          <el-col :span="4" style="text-align: right; padding-right: 50px">
            <div class="col-field" style="font-size: 14px">结算单状态</div>
            <div class="col-text settle-status">
              {{ settleStatusMap[form.settleStatus] }}
            </div>
          </el-col>
          <el-col :span="3" style="text-align: right; padding-right: 50px">
            <div class="col-field" style="font-size: 14px">结算方式</div>
            <div class="col-text settle-status">
              {{ payTypeMap[form.payType] }}
            </div>
          </el-col>
          <el-col :span="5" style="text-align: right">
            <div class="col-field" style="font-size: 14px">劳务费结算税前金额（元）</div>
            <div class="col-text settle-sum">{{ form.realAmount }}</div>
          </el-col>
        </el-row>
        <el-row :gutter="24" class="search-row" type="flex">
          <el-col :span="24" v-if="settleType != 2 && settleType != 3">
            <div class="col-field">代理：</div>
            <div class="col-text">{{ form.executorName }}</div>
          </el-col>
          <el-col :span="6" v-if="settleType == 2 || settleType == 3">
            <div class="col-field">调查员姓名：</div>
            <div class="col-text">{{ form.executorName }}</div>
          </el-col>
          <el-col :span="6" v-if="settleType == 2 || settleType == 3">
            <div class="col-field">调查员手机号：</div>
            <div class="col-text">{{ form.executorPhone }}</div>
          </el-col>
        </el-row>
        <el-row :gutter="24" class="search-row" type="flex" justify="space-between">
          <el-col :span="24">
            <div class="col-field">所属问卷：</div>
            <div class="col-text">{{ form.surveyTitle }}</div>
            <!-- <el-input type="textarea" v-model="form.surveyTitle" :autosize="{ minRows: 2, maxRows: 2}" :resize="false" :disabled="true"></el-input> -->
          </el-col>
        </el-row>
      </div>
      <div class="row-content">
        <div class="sub-content">
          <el-row class="search-row content-title" type="flex" justify="space-between">
            <el-col :span="24">
              <span>一、劳务费结算信息</span>
            </el-col>
          </el-row>
          <el-row :gutter="24" class="search-row content-detail" type="flex" justify="space-between">
            <el-col :span="6">
              <div class="col-field"><span v-if="isConfirm" style="color: red">* </span><span>银行卡号：</span></div>
              <div v-if="!isConfirm" class="col-text">
                {{ form.bankCardNumber }}
              </div>
              <el-input v-else type="text" placeholder="请输入" v-model="form.bankCardNumber"> </el-input>
            </el-col>
            <el-col :span="6">
              <div class="col-field"><span v-if="isConfirm" style="color: red">* </span><span>开户行信息：</span></div>
              <div v-if="!isConfirm" class="col-text">
                {{ form.bankCardInfo }}
              </div>
              <el-input v-else type="text" placeholder="请输入" v-model="form.bankCardInfo"> </el-input>
            </el-col>
            <el-col :span="6">
              <div class="col-field"><span v-if="isConfirm" style="color: red">* </span><span>收款人姓名：</span></div>
              <div v-if="!isConfirm" class="col-text">{{ form.payeeName }}</div>
              <el-input v-else type="text" placeholder="请输入" v-model="form.payeeName"> </el-input>
            </el-col>
          </el-row>
          <el-row :gutter="24" class="search-row content-detail" type="flex">
            <el-col :span="6">
              <div class="col-field">联系方式：</div>
              <div class="col-text">{{ form.executorPhone }}</div>
            </el-col>
          </el-row>
        </div>
        <div class="sub-content">
          <el-row class="search-row content-title" type="flex" justify="space-between">
            <el-col :span="24">
              <span>二、费用详情</span>
            </el-col>
          </el-row>
          <el-row :gutter="24" class="search-row content-detail" type="flex" justify="space-between">
            <el-col :span="6">
              <div class="col-field">实际结算费用（元）：</div>
              <div class="col-text">{{ form.realAmount }}</div>
            </el-col>
            <el-col :span="6">
              <div class="col-field">合格答卷数量：</div>
              <div class="col-text">{{ form.answerNum }}</div>
            </el-col>
            <el-col :span="6">
              <div class="col-field">结算费用合计（元）：</div>
              <div class="col-text">{{ form.totalAmount }}</div>
            </el-col>
            <el-col :span="6">
              <div class="col-field">调价金额（元）：</div>
              <div class="col-text">{{ form.adjustAmount }}</div>
            </el-col>
          </el-row>
          <el-row :gutter="24" class="search-row content-detail" type="flex">
            <el-col :span="6">
              <div class="col-field">调价原因：</div>
              <div class="col-text">{{ form.adjustDescribe }}</div>
            </el-col>
          </el-row>
        </div>
      </div>
      <div class="row-content">
        <el-row class="search-row content-title2" type="flex" justify="space-between">
          <el-col :span="24">
            <span>三、答卷明细</span>
          </el-col>
        </el-row>
        <data-table
          cell-class-name="truncate-table-cell-wrap"
          :data="data.slice((page.currentPage - 1) * page.pageSize, page.currentPage * page.pageSize)"
          :columns="option.column"
          :page="page"
          :showPage="true"
          :index="true"
          :loading="loading"
          @pagination-current-change="currentChange"
        >
        </data-table>
        <div class="btn-confirm" v-if="isConfirm">
          <el-button @click="toConfirm(false)">不认可</el-button>
          <el-button type="primary" @click="toConfirm(true)">认可</el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getSettlementDetail, settlementConfirm } from '@/api/wenjuan/settlement'
import { assignment } from '@/assets/js/utils'
import { settlementDetailOptions } from './geSettlementDetail'
import { payTypeMap } from '@/assets/js/config/payTypeMap'
import DataTable from '@/components/base/DataTable'
export default {
  components: {
    DataTable
  },
  props: {
    id: {
      type: String,
      default: ''
    },
    isConfirm: {
      type: Boolean,
      default: false
    },
    settleType: {
      // 0=委托方页面,1=代理页面,2=面访页面
      type: [Number, String],
      default: 0
    }
  },
  data() {
    return {
      option: settlementDetailOptions,
      loading: false,
      form: {},
      settleStatusMap: {
        1: '未发起',
        2: '待确认',
        3: '不认可',
        4: '已确认',
        5: '已撤销',
        6: '已结算',
        7: '已打款',
        8: '审批中',
        9: '审批已撤销',
        10: '审批拒绝'
      },
      payTypeMap,
      page: {
        total: 0, // 总页数
        currentPage: 1, // 当前页数
        pageSize: 10 // 每页显示多少条
        //pageSizes: [10, 20, 30, 50, 100],
      },
      data: []
    }
  },
  watch: {
    id(v) {
      this.getSettlementDetail()
    }
  },
  methods: {
    getSettlementDetail() {
      getSettlementDetail(this.id)
        .then(res => {
          let item = res.data.data
          item.realAmount =
            Number(item.realAmount) || item.realAmount == 0
              ? (Number(item.realAmount) / 100).toFixed(2)
              : Number(item.singleAmount).toFixed(2)
          item.totalAmount = Number(item.totalAmount)
            ? (Number(item.totalAmount) / 100).toFixed(2)
            : Number(item.totalAmount).toFixed(2)
          if (item.adjustAmount && item.adjustAmount != '0') {
            let sign = item.adjustAmount.substring(0, 1)
            let adjustAmountReal = item.adjustAmount.substring(1)
            item.adjustAmount = sign + (Number(adjustAmountReal) / 100).toFixed(2)
          } else {
            item.adjustAmount = ''
          }
          this.form = item
          res.data.data.answerSettles.forEach(item2 => {
            item2.realAmount = Number(item2.realAmount)
              ? (Number(item2.realAmount) / 100).toFixed(2)
              : Number(item2.singleAmount).toFixed(2)
            item2.singleAmount = Number(item2.singleAmount)
              ? (Number(item2.singleAmount) / 100).toFixed(2)
              : Number(item2.singleAmount).toFixed(2)
            if (item2.adjustAmount && item2.adjustAmount != '0') {
              let sign = item2.adjustAmount.substring(0, 1)
              let adjustAmountReal = item2.adjustAmount.substring(1)
              item2.adjustAmount = sign + (Number(adjustAmountReal) / 100).toFixed(2)
            } else {
              item2.adjustAmount = ''
            }
          })
          this.data = res.data.data.answerSettles
          this.page.total = res.data.data.answerSettles.length
        })
        .catch(err => {})
    },
    // 切换页面 （点击页码、数字、输入数字） 触发
    currentChange(val) {
      this.page.currentPage = val
    },
    toConfirm(isCon) {
      let params = {
        id: this.form.id,
        confirm: isCon,
        deniedReason: '',
        payeeName: this.form.payeeName,
        bankCardNumber: this.form.bankCardNumber,
        bankCardInfo: this.form.bankCardInfo
      }
      if (isCon && (!this.form.payeeName || !this.form.bankCardNumber || !this.form.bankCardInfo)) {
        this.$alert('未填写银行卡号或开户行信息，为保证结算顺利，请填写后再进行确认。', '结算信息不完整', {
          confirmButtonText: '去填写',
          customClass: 'confirm-box',
          showClose: false,
          callback: () => {
            return
          }
        })
      }
      if (isCon && this.form.payeeName && this.form.bankCardNumber && this.form.bankCardInfo) {
        this.$confirm('任务委托方将根据此费用为您结算劳务费，请注意查收。', '劳务费结算确认', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          customClass: 'confirm-box',
          showClose: false,
          type: 'warning'
        })
          .then(() => {
            settlementConfirm(params)
              .then(res => {
                this.$message({
                  showClose: true,
                  message: '已确认成功!',
                  type: 'success'
                })
                this.$emit('closeDrawer')
              })
              .catch(err => {})
          })
          .catch(() => {})
      }
      if (!isCon) {
        this.$prompt('<span style="color:red;">* </span><span>不认可原因：</span>', '劳务费结算确认', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          customClass: 'confirm-box',
          showClose: false,
          inputValidator: value => {
            if (!value) {
              return '请填写原因'
            } else {
              return true
            }
          },
          dangerouslyUseHTMLString: true
        })
          .then(({ value }) => {
            params.deniedReason = value
            settlementConfirm(params)
              .then(res => {
                this.$message({
                  showClose: true,
                  message: '不认可状态更新成功!',
                  type: 'success'
                })
                this.$emit('closeDrawer')
              })
              .catch(err => {})
          })
          .catch(() => {})
      }
    }
  },
  created() {}
}
</script>
<style scoped lang="scss">
.wrap {
  width: 100%;

  ul {
    display: flex;
    margin-bottom: 20px;

    li {
      width: 101px;
      height: 36px;
      border-radius: 0px 4px 4px 0px;
      border: 1px solid rgba(220, 223, 230, 1);
      display: inline-flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(48, 49, 51, 1);
    }
  }
}
.tips {
  position: absolute;
  top: 2px;
  right: 0px;
  cursor: pointer;
}
.tips-btn {
  position: relative;
}
::v-deep.el-table th div {
  line-height: 23px;
  white-space: normal;
  padding-left: 0px;
  display: block;
}
.tips-p {
  position: absolute;
  top: -40px;
  right: 115px;
  cursor: pointer;
  margin: 0;
}
.tips-p2 {
  position: absolute;
  top: -40px;
  right: 118px;
  cursor: pointer;
  margin: 0;
}
.bach-red {
  color: red;
  font-size: 18px;
  font-weight: 600;
}
.bach-blue {
  color: blue;
  font-size: 18px;
  font-weight: 600;
}
.bach-line {
  margin-bottom: 25px;
  padding-left: 10px;
}
.sum-line {
  position: absolute;
  bottom: 4px;
  left: 70px;
  .el-button {
    margin-left: 20px;
  }
}
::v-deep.avue-crud__tip {
  display: none;
}
::v-deep.el-table__body {
  a {
    margin-right: 10px;
    color: #227ffe;
  }
}
.t-content {
  border-right: 1px solid #333;
  border-bottom: 1px solid #333;
  background-color: #fff;
  .el-col {
    border-left: 1px solid #333;
    border-top: 1px solid #333;
    margin-bottom: 0px;
  }
}
.btn-confirm {
  text-align: right;
  padding-top: 10px;
  border-top: 1px solid rgba(0, 0, 0, 0.09);
  .el-button {
    width: 84px;
  }
  // .el-button+.el-button {
  //   margin-left: 10px;
  // }
}
.row-content {
  background-color: #fff;
  margin-bottom: 10px;
  padding: 10px 20px;
}
.bc {
  background-color: #f5f5f5;
}
::v-deep.el-input.is-disabled .el-input__inner,
::v-deep.el-textarea.is-disabled .el-textarea__inner {
  background-color: #eeeeee;
  color: rgb(0, 0, 0);
  font-size: 12px;
  cursor: default;
  height: 32px;
  border: 1px solid #dddddd;
  border-radius: 4px;
}
.sub-content {
  background: #eeeeee;
  border: 1px solid #d8d8d8;
  margin: 20px 0;
  .content-detail {
    height: 70px;
    padding: 10px 17px;
  }
  .content-title {
    border-bottom: 1px solid #d8d8d8;
    margin: 0px;
    height: 40px;
    padding: 8px 17px;
    opacity: 0.85;
    font-size: 16px;
    text-align: left;
    color: #000000;
  }
}
.content-title2 {
  opacity: 0.85;
  font-size: 16px;
  color: #000000;
}
.col-field {
  opacity: 0.45;
  font-size: 12px;
  color: #000000;
  line-height: 22px;
  font-weight: 500;
}
.col-text {
  opacity: 0.85;
  font-size: 14px;
  color: #000000;
  line-height: 22px;
}
.settle-status {
  color: #000;
  font-size: 18px;
}
.settle-sum {
  color: #d61508;
  font-size: 20px;
  padding-right: 15px;
}
::v-deep.el-table__row {
  background-color: #ffffff !important;
}
::v-deep.el-table__row--striped td {
  background-color: #f5f5f5 !important;
}
.avue-crud ::v-deep.el-table th {
  background-color: #f5f5f5;
}
::v-deep.el-table__fixed {
  height: 100% !important;
}
</style>
